import React from "react";
import {BaseThatsMeIconProps} from "../../interfaces/baseThatsMeIconProps.interface";

export default (props: BaseThatsMeIconProps) => {
    const {size = 40, ...rest} = props;
    return <svg width={size} height={size} viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
        <rect width={size} height={size} rx="20" fill="black"/>
        <path
            d="M8.05854 8.51019L17.3256 20.9387L8 31.0408H10.1L18.2622 22.1937L24.8585 31.0408H32L22.2134 17.9151L30.8915 8.51019H28.7951L21.2768 16.6564L15.2037 8.51019H8.05854ZM11.1463 10.0587H14.428L28.9159 29.4886H25.6341L11.1463 10.0587Z"
            fill="white" />
    </svg>
}